import gql from 'graphql-tag';
import { apolloClient } from 'services/apollo';

export const IDENTIFY_MUTATION = gql`
  mutation identify($event: IdentifyInput) {
    identify(event: $event)
  }
`;

export const TRACK_EVENT = gql`
  mutation trackEvent($event: EventInput) {
    trackEvent(event: $event)
  }
`;

export const track = (eventType, properties) =>
  apolloClient
    .mutate({ variables: { event: { eventType, properties: JSON.stringify(properties) } }, mutation: TRACK_EVENT })
    // eslint-disable-next-line no-console
    .catch(err => console.error(`Track event error: ${err}`));

export const identify = async () =>
  apolloClient
    .mutate({ mutation: IDENTIFY_MUTATION, variables: { event: { traitProperties: '{}' } } })
    // eslint-disable-next-line no-console
    .catch(err => console.error(err));
